import {Accordion, AccordionDetails, AccordionSummary, Box, Link, Paper, Stack, Typography} from "@mui/material";
import {useMainContext} from "../constants";
import {ExpandMore} from "@mui/icons-material";

export default function Girls() {

    const { mainVariant, smallVariant, smallerVariant, smallestVariant } = useMainContext();

    return (
        <Box sx={{ maxWidth: 'lg',
            paddingLeft: { xs: "10px", sm: "20px", md: "30px"},
            paddingRight: { xs: "10px", sm: "20px", md: "30px"},
            paddingBottom: { xs: "10px", sm: "20px", md: "30px"},
            marginLeft: "auto", marginRight: "auto" }}>
            <Stack direction="column" spacing={2} sx={{ marginTop: { xs: "10px", sm: "15px", md: "20px"}}}>
                <Typography variant={ smallerVariant } sx={{ fontWeight: "bold"}}>Girls Varsity Basketball</Typography>
                <Typography variant="body1">
                    The Girls Varsity Team is a member of the Greater Finger Lakes Christian Athletic Association (GFLCAA). Games are played in Rochester, Syracuse, Elmira, Cayuga County, Buffalo, & Olean. We try to schedule as many games as possible and often play small Christian or private schools and CYO teams within a two-hour drive from Rochester. We complete our season by attending the NCSAA Basketball Championships at Mt Vernon Nazarene University in Mt Vernon, Ohio. This tournament is optional & requires travel, additional cost, & overnight stay.
                </Typography>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore/>} data-testid="girlsBasketballJV">
                        <Typography variant={smallestVariant}>Girls JV Basketball</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body1">
                            The JV girls team focuses on skill development, basketball game knowledge, and experience. JV girls and Varsity girls practice together for a portion of practice. The JV girls team is mostly 9th-11th graders, with occasional younger players selected at the coach’s discretion. The JV team will mainly play local CYO teams and may have games up to 2hr drivetime from Rochester. There are no JV playoffs but may enter a local tournament at the end of the season.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore/>} data-testid="girlsBasketballModified">
                        <Typography variant={smallestVariant}>Girls Modified Basketball</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body1">
                            The Girls  Modified Team encompasses grades 5 – 8 and plays in the Western New York Christian Athletic Association (WNYCAA). This league plays about 10 – 12 games in the Rochester area. Almost all of the games are on Tuesday & Thursday starting at 4:00. At the modified level, we focus on skill and technique development, team play, and the basics of basketball.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Typography variant="body1">
                    If you are interested in participating this season, please reach out to Jake and Tabi Carbone. We send out emails with information regarding off season work outs, season information, and team activities. Season specific information will be sent out at the end of October.
                    <br/>
                    <br/>
                    If you have any questions about the girls basketball program, please contact us at <a href="emailto:jakeandtabcarbone@gmail.com">jakeandtabcarbone@gmail.com</a>
                </Typography>
            </Stack>
        </Box>
    )
}
